

























































































































































import { Mixins, Component, Prop, Watch } from 'vue-property-decorator';
import { AxPage } from '@/mixins';

import * as I from '@/interfaces';
import * as U from '@/utils';

import AxAPI from '@/api';

type PageInfo = I.MealSettingPageInfo;

class OperCodeType {
  operCode = 'L';
  name = '분실';
}

type CardList = {};
type CashList = {};

type DataItem = U.DataItem<I.TempEmployee, State>;
type DataStore = U.DataStore<I.TempEmployee>;

type UpdateItemParam = I.PacketMealTimeUpdate;

const DataStore = U.DataStore;

class BatchDialogState {
  show: boolean;
  title: string;
  groupFlag: string;
  doorFlag: string;
  selectGroup: string;
  selectDoor: string;
  companyCode: I.CodeData;
  deptCodeA: I.CodeData;
  deptCodeB: I.CodeData;
  dutyCodeA: I.CodeData;
  listCompanyCode: I.CodeData[];
  userStatus: I.CodeData;
  listDeptCodeA: I.CodeData[];
  listDeptCodeB: I.CodeData[];
  listDutyCodeA: I.CodeData[];
  listUserStatus: I.CodeData[];
  listDoor: I.DoorData[];
  listGroup: I.DoorData[];
  selected: I.CodeData;
  periodFrom!: Date; // = new Date('2050-12-31').toISOString().substr(0, 10);
  periodTo!: Date; // = new Date('2050-12-31').toISOString().substr(0, 10);
  groupzoneCode: number;
  doorzoneCode: number;
  callback: () => Promise<void>;

  constructor() {
    this.show = false;
    this.title = '';
    this.groupFlag = 'I';
    this.doorFlag = 'I';
    this.selectGroup = '';
    this.selectDoor = '';
    this.selected = { code: '', name: '', dataType: '', etc: '' };
    this.companyCode = { code: '', name: '', dataType: '', etc: '' };
    this.deptCodeA = { code: '', name: '', dataType: '', etc: '' };
    this.deptCodeB = { code: '', name: '', dataType: '', etc: '' };
    this.dutyCodeA = { code: '', name: '', dataType: '', etc: '' };
    this.userStatus = { code: '', name: '', dataType: '', etc: '' };
    this.listCompanyCode = [];
    this.listDeptCodeA = [];
    this.listDeptCodeB = [];
    this.listDutyCodeA = [];
    this.listUserStatus = [];
    this.listDoor = [];
    this.listGroup = [];
    this.groupzoneCode = 1;
    this.doorzoneCode = 1;
    this.periodFrom = null;
    this.periodTo = null;
    this.callback = async () => {};
  }
}

class State {
  listUser: I.TempEmployee[];
  cardstatus: string;
  cardno: string;
  constructor() {
    this.listUser = [];
    this.cardstatus = '' as never;
    this.cardno = '' as never;
  }
}

abstract class BaseClass extends Mixins(AxPage) {
  API!: AxAPI;
  dataItem!: DataItem;
}

interface BaseInterface extends BaseClass {}

@Component
class ApiHandler extends BaseClass {
  async getUserInfo() {
    const search = this.dataItem.search;
    const result = await this.API.call.temp.tempCardSearch(search);
    console.log(result);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }
}

@Component
class DataItemHandler extends BaseClass {
  dataItems: DataItem[] = [
    {
      name: '사원',
      store: new DataStore<I.TempEmployee>({
        headers: {
          name: '성명',
          companyName: '회사',
          deptNameA: '사업장',
          cardNo: '카드번호'
        }
      }),
      search: '',
      description: [],
      state: new State()
    }
  ];

  get dataItem() {
    return this.dataItems[0];
  }
}

@Component
class BaseData extends Mixins(AxPage) implements BaseInterface {
  dataItem!: DataItem;
  pageInfo?: I.UserSearchPageInfo;

  on = true;
  width = 400;
  height = 270;

  @Prop({ default: () => new I.DataParam() })
  param!: I.DataParam;

  listOperType: OperCodeType[] = [
    { operCode: 'L', name: '분실' },
    { operCode: 'X', name: '훼손' },
    { operCode: 'C', name: '교체' }
  ];

  @Watch('on')
  onSwitchChanged() {
    this.$emit('changed', this.on);
  }

  showCompanyCodeSelectDialog() {
    if (!this.pageInfo) return;

    this.showCodeSelectDialog({
      title: '회사 검색',
      param: {
        items: this.pageInfo.listCompanyCode,
        selected: [this.batchDialogState.companyCode],
        callback: async (selected: I.CodeData[]) => {
          if (selected.length) {
            this.batchDialogState.companyCode = selected[0];
          } else {
            this.batchDialogState.companyCode = { code: '', name: '' };
          }
        }
      },
      single: true
    });
  }

  showDeptCodeASelectDialog() {
    if (!this.pageInfo) return;

    this.showCodeSelectDialog({
      title: '사업장 검색',
      param: {
        items: this.pageInfo.listDeptCodeA,
        selected: [this.batchDialogState.deptCodeA],
        callback: async (selected: I.CodeData[]) => {
          if (selected.length) {
            this.batchDialogState.deptCodeA = selected[0];
          } else {
            this.batchDialogState.deptCodeA = { code: '', name: '' };
          }
        }
      },
      single: true
    });
  }

  showDeptCodeBSelectDialog() {
    if (!this.pageInfo) return;

    this.showCodeSelectDialog({
      title: '부서 검색',
      param: {
        items: this.pageInfo.listDeptCodeB,
        selected: [this.batchDialogState.deptCodeB],
        callback: async (selected: I.CodeData[]) => {
          if (selected.length) {
            this.batchDialogState.deptCodeB = selected[0];
          } else {
            this.batchDialogState.deptCodeB = { code: '', name: '' };
          }
        }
      },
      single: true
    });
  }

  showUserStatusSelectDialog() {
    if (!this.pageInfo) return;

    this.showCodeSelectDialog({
      title: '상태 검색',
      param: {
        items: this.pageInfo.listUserStatus,
        selected: [this.batchDialogState.userType],
        callback: async (selected: I.CodeData[]) => {
          if (selected.length) {
            this.batchDialogState.userStatus = selected[0];
          } else {
            this.batchDialogState.userStatus = { code: '', name: '' };
          }
        }
      },
      single: true
    });
  }

  ClickOpenGroupBatch() {
    type GroupPrivParams = { title: string; param: I.DataParam };

    this.batchDialogState.listGroup = [];
    this.batchDialogState.selectGroup = '';

    const listAllGroup = this.pageInfo?.listGroup.filter(
      x => x.zoneCode === this.batchDialogState.groupzoneCode
    );
    if (!listAllGroup) return;

    const dialogParams = new I.DialogParam<GroupPrivParams>('AxDeviceSelectDialog', {
      title: '출입문 그룹 선택',
      param: {
        items: listAllGroup,
        selected: [],
        callback: async () => {
          const selected = dialogParams.props.param.selected as I.DoorData[];

          this.batchDialogState.listGroup = selected;
          this.batchDialogState.selectGroup = selected.length.toString() + '개 선택';
        }
      }
    });
    this.showDialog(dialogParams);
  }

  ClickOpenDoorBatch() {
    type GroupPrivParams = { title: string; param: I.DataParam };
    this.batchDialogState.listDoor = [];
    this.batchDialogState.selectDoor = '';

    const listAllDoor = this.pageInfo?.listDoor.filter(
      x => x.zoneCode === this.batchDialogState.doorzoneCode
    );
    if (!listAllDoor) return;

    const dialogParams = new I.DialogParam<GroupPrivParams>('AxDeviceSelectDialog', {
      title: '출입문 선택',
      param: {
        items: listAllDoor,
        selected: [],
        callback: async () => {
          const selected = dialogParams.props.param.selected as I.DoorData[];

          this.batchDialogState.listDoor = selected;
          this.batchDialogState.selectDoor = selected.length.toString() + '개 선택';
        }
      }
    });
    this.showDialog(dialogParams);
  }

  async OnClickBatchUpdate() {
    console.log('batch', this.batchDialogState);
    this.param.selected = [this.batchDialogState];
    this.param.callback();
    this.on = false;
  }

  showDutyCodeASelectDialog() {
    if (!this.pageInfo) return;

    this.showCodeSelectDialog({
      title: '직급 검색',
      param: {
        items: this.pageInfo.listDutyCodeA,
        selected: [this.batchDialogState.dutyCodeA],
        callback: async (selected: I.CodeData[]) => {
          if (selected.length) {
            this.batchDialogState.dutyCodeA = selected[0];
          } else {
            this.batchDialogState.dutyCodeA = { code: '', name: '' };
          }
        }
      },
      single: true
    });
  }
}

const Handlers = Mixins(Mixins(ApiHandler, DataItemHandler));

@Component
export default class AxBatchUpdateDialog extends Mixins(BaseData, Handlers) {
  batchDialogState = new BatchDialogState();
  async getPageInfo() {
    const result = await this.API.call.user.userSearchPageInfo();
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  async prepare() {
    const baseData = await this.getPageInfo();
    if (baseData) {
      this.pageInfo = baseData;
      this.pageInfo.listUserStatus.push({ code: '9', name: '삭제' });
    }
  }
}
